export default {
    name: 'SymplaEvents'
}
